import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * The Shared teams page's old address. There are no church-wide teams any
 * more (docs/14, 2026-10-21): every team serves one or more service types,
 * as in Planning Center, and is managed in their settings. Old links land
 * on Plans.
 */
export const Route = createFileRoute('/_authed/_shell/services/shared-teams')({
  beforeLoad: () => {
    throw redirect({ to: '/services/plans', replace: true })
  },
})
